import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import IoTFlowsLogo from '../IoTFlowsLogoBlackFont.png';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect
  } from "react-router-dom";
import Amplify, { Auth, Hub } from 'aws-amplify';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';

Amplify.configure({
    Auth: {            
        identityPoolId: 'us-east-1:5684b65a-8bf4-4697-b9a4-87eadbf03ef5',
        region: 'us-east-1',
        identityPoolRegion: 'us-east-1',      
        userPoolId: 'us-east-1_3EP1MRzAy',  
        userPoolWebClientId: '18230ih88kfb3ouj67mrid5er3',
        oauth: {
            domain: 'auth.iotflows.com',
            scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            // redirectSignIn: 'https://www.console.iotflows.com/', 
            // redirectSignOut: 'https://www.console.iotflows.com/', 
            redirectSignIn: 'http://localhost:3000/', 
            redirectSignOut: 'http://localhost:3000/', 
            responseType: 'token', // DO NOT USE 'code'!!! it goes through a forever loop //or 'token', note that REFRESH token will only be generated when the responseType is code
            // responseType: 'code', 
            options: {
                // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
                AdvancedSecurityDataCollectionFlag : true
            },
        }
    }
});



const styles = theme => ({
    root: {
        flexGrow: 1,
        height: '100vh',
        overflow:'scroll',
    },
    loginContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '540px',
        paddingTop: '56px',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '382px',
            paddingTop: '28px',
        },
    },
    logoContainer: {
        marginLeft:'12px',
        paddingLeft: '16px',
        paddingBottom: '40px',
        textAlign: 'left',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '20px',
            paddingBottom: '24px',
        },
    },
    loginSection: {
        width: '540px',
        color: '#424770',
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '56px 48px',
        webkitBoxShadow:  '0 30px 60px -12px rgb(50 50 93 / 25%), 0 18px 36px -18px rgb(0 0 0 / 30%), 0 -12px 36px -8px rgb(0 0 0 / 3%)',
        boxShadow: '0 30px 60px -12px rgb(50 50 93 / 25%), 0 18px 36px -18px rgb(0 0 0 / 30%), 0 -12px 36px -8px rgb(0 0 0 / 3%)',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '32px 20px',
            margin:'0px 16px'
        },
    },
    loginTitleContainer: {
        marginLeft: '12px',
        textAlign: 'left',
    },
    loginTitle: {
        fontSize: '24px',
        fontWeight: 500,
        lineHeight: '32px',
        fontFamily: 'sohne-var,sohne-woff,Helvetica Neue,Arial,sans-serif',
        letterSpacing: '-.2px',
        color: '#3c4257',
    },
    inputSection: {
        marginBottom: '12px',
    },
    inputContainers: {
        textAlign: 'left',
        marginLeft: '12px',
        marginTop:'12px',
    },
    labelCSS: {
        marginBottom: '0px',
        textAlign: 'left',
    },
    loginHeader: {
        lineHeight: '20px',
        fontWeight: 500,
        fontSize: '14px',
        color: '#3c4257',
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',
    },
    inputCSS: {
        // backgroundColor: '#f6f9fc',
        backgroundColor: '#fff',
        color: 'rgb(60, 66, 87)',
        display: 'block',
        width: '100%',
        height: 'calc(1.5em + .75rem + 2px)',
        padding: '.375rem .75rem',
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.5,
        backgroundClip: 'padding-box',
        border: '1px solid #ced4da',
        webkitAppearance: 'none',
        mozAppearance: 'none',
        appearance: 'none',
        borderRadius: '.25rem',
        webkitFontSmoothing: 'antialiased',
        transition: 'background-color .24s,box-shadow .24s',
        '&:focus': {
            transition: 'background-color .24s,box-shadow .24s',
            borderColor: 'rgba(142, 183, 248, 1)',
            outline: 0,
            webkitBoxShadow: 'rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(58 151 212 / 36%) 0px 0px 0px 4px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px',
            mozBoxShadow: 'rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(58 151 212 / 36%) 0px 0px 0px 4px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px',
            boxShadow: 'rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(58 151 212 / 36%) 0px 0px 0px 4px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px',
        },
    },
    forgotCSS: {
        textAlign: 'left',
        textDecoration: 'none',
        lineHeight: '20px',
        fontWeight: 500,
        fontSize: '14px',
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',
        color: '#2563EB',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'none',
            color: '#3c4257',
        },
    },
    loginButtonContainer: {
        marginLeft: '12px',
        marginTop: '24px',
    },
    loginButton: {
        backgroundColor: '#2563EB',
        color: '#fff',
        border: 'none',
        fontWeight: 500,
        padding: '4px 14px',
        fontSize: '16px',
        letterSpacing: '.025em',
        lineHeight: '28px',
        borderRadius: '4px',
        width: '100%',
        '&:hover': {
            backgroundColor: '#2563EB', 
            opacity: 0.8,
        },
    },
    signupContainer: {
        textAlign: 'left',
        paddingTop: '32px',
        paddingLeft: '20px',
    },
    signupMessage: {
        display: 'flex',
        lineHeight: '20px',
        color: '#3c4257',
        fontWeight: 400,
        fontSize: '14px',
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',
    },
    footerPositioner: {
        position: 'relative',
        // bottom: '10px',
        // display: 'flex',
        // flexDirection: 'column',
    },
    spacer: {
        flexGrow: 1,
        flexShrink: 1,
    },
    legal_footer: {
        padding: '12px',
    },
    legal_item: {
        textDecoration: 'none',
        color: '#606972',
        padding: '8px',
        textAlign: 'center',
        fontSize: '14px',
        '&:hover': {
            textDecoration: 'none',
            color: 'rgba(96, 105, 114, 0.8)',
            cursor: 'pointer',
        },
    },
    angledDiv: {
        position: 'fixed',
        left: 0,
        right: 0,
        top: '-250px',
        bottom: 0,
        zIndex: -1,
        transform: 'skewY(-12deg)',
    },
    largeGreyBackground: {
        position: 'absolute',
        top: '-1000px',
        left: 0,
        right: 0,
        transformOrigin: '0 50%',
        height: '1630px',
        // backgroundColor: '#f7fafc',
        backgroundColor: '#F3F4F6', //dark
    },
    leftStripeBackground: {
        top: '630px',
        left: '-10px',
        right: 'calc(50% + 505px)',
        height: '50px',
        backgroundColor:'#60A5FA',
        position: 'absolute',
        [theme.breakpoints.up('xl')]: {
            right: 'calc(50% + 605px)',
        },
        [theme.breakpoints.down('md')]: {
            right: 'calc(50% + 135px)',
        },
    },
    rightStripeBackground: {
        top: '580px',
        right: '-10px',
        left: 'calc(100% - 230px)',
        height: '50px',
        backgroundColor:'#60A5FA',
        position: 'absolute',
        [theme.breakpoints.down('md')]: {
            left: 'calc(100% - 110px)',
        },
    },
    textCSS: {
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',
        lineHeight: '20px',
        fontWeight: 400,
        fontSize: '14px',
        color: '#3c4257',
    },
    resendCSS: {
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',
        lineHeight: '20px',
        fontWeight: 400,
        fontSize: '14px',
        color: '#3B82F6',
        cursor:'pointer',
        '&:hover': {
            color: '#2563EB',
        },
    },
    passwordMessage: {
        lineHeight: '16px',
        fontSize: '12px',
        // color: '#cd3d64',
        fontWeight: 400,
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif',

    }
   
  });

class Reset extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            username: this.props.location.state.username,
            code: '',
            redirect: false,
            toPath:'',
            showConfirmPassword: false,
            issueMessage: '',
            errorPopup: false,
        }
    }

    handleLoginRouting = () => {
        this.setState(
            {
                redirect: true,
                toPath: '/login',
            }, () => {
                this.setState({redirect: false})
            })
    }

    resendConfirmation = () => {
        try {
            Auth.resendSignUp(this.props.location.state.username)
            .then(data => {
                // console.log('resend data', data)
                this.props.showSuccessSnackbar('Verification email has been sent')
            })
            .catch(err => {
                // console.log('err', err)
                this.props.showErrorSnackbar(err);
                }
            );
        } catch (err) {
            console.log('error resending code: ', err);
            // this.props.showErrorSnackbar(err.message)
        }
    }

    render() {
        const { classes} = this.props
        const { toPath,
                redirect, } = this.state

        if (redirect) {
            return <Redirect push to={toPath} />
          }



        return (
            <div className={classes.root}>
                <div className={classes.angledDiv}>
                    <div className={classes.largeGreyBackground}>
                    </div>
                    <div className={classes.leftStripeBackground}>
                    </div>
                    <div className={classes.rightStripeBackground}>
                    </div>
                </div>
                
                <div className={classes.loginContainer}>
                    <div className={classes.logoContainer}>
                        <img src={IoTFlowsLogo} height="40px" alt="IoTFlows Inc" loading="lazy" />
                    </div>
                    <div className={classes.loginSection}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div className={classes.loginTitleContainer} >
                                <span className={classes.loginTitle} >Thanks, check your email for a verification link to activate your account.</span>
                            </div>

                            <div className={classes.inputContainers} >
                                <span className={classes.textCSS} >Didn't get the email? Check your spam folder or <span onClick={this.resendConfirmation} className={classes.resendCSS} >resend</span></span>
                            </div>
                        </div>
                        <div style={{marginTop: '24px'}}>
                            <div onClick={this.handleLoginRouting} className={classes.forgotCSS} style={{textAlign: 'center'}}>Return to login</div>
                        </div>

                    </div>

                    <div className={classes.spacer}/>
                    <section className={classes.footerPositioner} >
                        <div className={classes.legal_footer} >
                            <a className={classes.legal_item} href="https://www.iotflows.com/" >©IoTFlows Inc 2021</a>
                            <a className={classes.legal_item} href="https://www.iotflows.com/policies/terms-of-use/" >Terms of Use</a>
                            <a className={classes.legal_item} href="https://www.iotflows.com/policies/private-policy/" >Private Policy</a>
                        </div>
                    </section>
                </div>
                
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
    showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),
  
  })
  
  const mapStateToProps = state => {
    return {
      searchbarUsername: state.searchbarUser.searchbarUsername
    }
  }

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(Reset));
